import Vuex from 'vuex';
import * as actionTypes from './actionTypes';
import mutations from './mutations';

export default setting => {
  return new Vuex.Store({
    state: {
      setting,
      pingData: {},
      iframes: [],
      mqttConfig: { debugSubscriptions: {} },
      loading: false,
      appDetails: [],
      isServicesConfigured: {
        rubixBios: true,
        rubixService: true,
      },
      rubixAppVersion: { version: '' },
      installedServices: [],
      systemDefaultApps: [],
      mqttRestBridgeConfig: {},
      isFetchingRestBridgeConfig: true,
      isMaster: null,
      rerenderCount: 0,
      currentBulkAppDownloadState: '',
      isSwitchedSlave: false,
      showOverlay: false,
      rfAvailable: false,
      mbNetworks: [],
      rdNetworks: [],
      bmNetworks: [],

      rfCommandGroupsUUIDs: [],
      rfCommandGroups: [],

      rfStreams: [],
      rfFlowNetworks: [],
      rfNetworks: [],
      rfPlugins: [],
      rfDevices: [],
      rfPoints: [],
      rfWriters: [],
    },
    mutations: {
      ...mutations,
      [actionTypes.UPDATE_SYSTEM_DEFAULT_APPS](state, payload) {
        state.systemDefaultApps = payload;
      },
      [actionTypes.UPDATE_RUBIX_SERVICE_VERSION](state, payload) {
        state.rubixAppVersion = payload;
      },
    },
  });
};
